// extracted by mini-css-extract-plugin
export default {"oldPrice":"OldPrice__oldPrice___zMIYE","special":"OldPrice__special___WJ7Q6","cross":"OldPrice__cross___yVdq6"};